<template>
  <div class="bodyTempoExpirado">
    <div class="alignMobile">
      <img
        style="margin: 15px auto 25px auto; display: block"
        src="/img/logo_pagseguro.png"
        width="250px"
        alt="PagSeguro Logo"
      />
      <p style="font-weight: bold">Oferta expirada</p>
      <p>Para negociar ligue</p>
      <p class="mb-8"><a href="tel:08005252030"> 0800 525 2030</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TempoExpirado",
  mounted() {
    localStorage.clear();
  },
};
</script>

<style scoped>
.bodyTempoExpirado {
  font-family: "Nunito", sans-serif;
  background-color: white;
  width: 600px;
  border-radius: 8px;
  padding-bottom: 25px;
  padding-top: 5px;
  margin-top: 30px;
}

.alignMobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

p {
  margin: 5px;
  text-align: center;
  font-size: 22px;
}

@media (max-width: 600px) {
  .bodyTempoExpirado {
    width: 95vw;
    margin-top: 30px;
  }
}
</style>